import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgGo = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-go';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.24 12v8.76h17.52V3.24H3.24zm16 0v7.24H4.76V4.76h14.48zm-4.078-3.197c-.5.065-1.117.306-1.557.607a5.4 5.4 0 0 0-.907.872c-.533.693-.768 1.451-.728 2.344.037.79.297 1.4.825 1.931.317.319.549.475.953.644.834.347 1.834.303 2.715-.121.385-.185.661-.386 1.031-.75.724-.713 1.105-1.583 1.108-2.535a4 4 0 0 0-.038-.621c-.25-1.284-1.239-2.211-2.533-2.373a2.7 2.7 0 0 0-.869.002m-6.86.039q-1.306.205-2.275 1.318a3.7 3.7 0 0 0-.81 1.637c-.087.439-.061 1.227.054 1.588.576 1.805 2.561 2.596 4.359 1.736.43-.205.64-.352 1.015-.711.788-.752 1.088-1.465 1.212-2.88l.022-.25H8.64v1.48h1.402l-.064.124c-.114.22-.622.697-.88.827-.395.199-.664.26-1.054.241-1.692-.082-1.896-2.291-.306-3.32.366-.237.705-.325 1.174-.304.444.019.683.115.989.397l.174.161.601-.413c.33-.227.601-.423.602-.435.004-.053-.429-.499-.627-.644a3.5 3.5 0 0 0-1.031-.495c-.295-.077-.997-.108-1.318-.057m7.989 1.568c1.002.462 1.102 1.838.202 2.792-.406.429-.794.642-1.304.713-.713.1-1.399-.263-1.632-.865-.127-.326-.127-.848-.001-1.221.176-.523.617-1.036 1.122-1.305.371-.197.568-.243 1.002-.231.313.009.421.029.611.117"
    })
  }));
});
export default SvgGo;